import { StyledAsterisk } from './RequiredAsterisk.styles';

const RequiredAsterisk = () => <StyledAsterisk>*</StyledAsterisk>;

export default RequiredAsterisk;
